import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";

import ReachOptions from "./options/ReachOptions";
import Options from "./options/Options";

const config = {
  botName: "Pomoć pticama",
  initialMessages: [
    createChatBotMessage(`Zdravo! Ako ste pronašli pticu kojoj je potrebna pomoć, pružiću Vam savet, ali mi je potrebno par odgovora. Da li ptić krvari ili ima vidljivu povredu?`, {
      widget: "optionsInjured",
    }),
  ],


  widgets: [
    {
      widgetName: "optionsInjured",
      widgetFunc: (props) => <Options {...props} ops='optionsInjured'/>,
    },
    {
      widgetName: "optionsStage",
      widgetFunc: (props) => <ReachOptions {...props} />,
    },
    {
      widgetName: "optionsLocations",
      widgetFunc: (props) => <Options {...props} ops='optionsLocations'/>,
    },
  ],
};

export default config;
